import { useMutation } from "@apollo/client";
import CreateMailerConfigMutation from "../graphql/mutations/CreateMailerConfigMutation.graphql";
import UpdateMailerConfigMutation from "../graphql/mutations/UpdateMailerConfigMutation.graphql";
import DeleteMailerConfigsMutation from "../graphql/mutations/DeleteMailerConfigsMutation.graphql";
import RestoreMailerConfigsMutation from "../graphql/mutations/RestoreMailerConfigsMutation.graphql";
import TestMailerConfigMutation from "../graphql/mutations/TestMailerConfigMutation.graphql";

export function useCreateMailerConfigMutation() {
  return useMutation(CreateMailerConfigMutation);
}

export function useUpdateMailerConfigMutation() {
  return useMutation(UpdateMailerConfigMutation);
}

export function useDeleteMailerConfigsMutation() {
  return useMutation(DeleteMailerConfigsMutation);
}

export function useRestoreMailerConfigsMutation() {
  return useMutation(RestoreMailerConfigsMutation);
}

export function useTestMailerConfigMutation() {
  return useMutation(TestMailerConfigMutation);
}
